import CoursesApiService from "./api/CoursesApiService";
import { formatPayloadToQueryString } from "@/utils/formatters";
import axios from "axios";

export const getEnrollments = async (payload, userToken) => {
    const queryString = formatPayloadToQueryString({
        courseId: payload?.courseId,
        userId: payload?.userId,
        status: payload?.status,
        curriculumId: payload?.curriculumId,
        classroomId: payload?.classroomId,
        periodId: payload?.periodId,
        organizationId: payload?.organizationId,
        userName: payload?.userName,
        page: payload?.page,
        perPage: payload?.perPage,
        trashed: payload?.trashed
    });

    try {
        const response = await CoursesApiService.get(`/enrollments${queryString}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar matrículas', error);

        throw error;
    }
}

export const getEnrollmentById = async (enrollmentId, userToken) => {
    try {
        const response = await CoursesApiService.get(`/enrollments/${enrollmentId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao buscar matrícula', error);

        throw error;
    }
}

export const createEnrollment = async (payload, userToken) => {
    try {
        const response = await CoursesApiService.post('/enrollments', payload, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao criar matrícula', error);

        throw error;
    }
}

export const updateEnrollment = async (payload, userToken) => {
    const { enrollmentId, ...enrollment } = payload;

    try {
        const response = await CoursesApiService.put(`/enrollments/${enrollmentId}`, enrollment, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch (error) {
        console.error('Erro ao atualizar matrícula', error);

        throw error;
    }
}

export const deleteEnrollment = async (enrollmentId, userToken) => {
    try {
        await CoursesApiService.delete(`/enrollments/${enrollmentId}`, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    } catch (error) {
        console.error('Erro ao excluir matrícula', error);

        throw error;
    }
}

export const restoreEnrollment = async (enrollmentId, userToken) => {
    try {
        await CoursesApiService.post(`/enrollments/${enrollmentId}/restore`, {}, {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });
    } catch (error) {
        console.error('Erro ao restaurar matrícula', error);

        throw error;
    }
}

export const fetchAddressByCep = async (cep) => {
    try {
        const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

        if (response.data.erro) {
            throw new Error('CEP não encontrado');
        }

        return {
            address: response.data.logradouro || '',
            city: response.data.localidade || '',
            state: response.data.estado || '',
            country: 'Brasil',
        };
    } catch {
        throw new Error('Falha ao buscar endereço pelo CEP, tente novamente em breve');
    }
}

export default {
    getEnrollments,
    getEnrollmentById,
    createEnrollment,
    updateEnrollment,
    deleteEnrollment,
    restoreEnrollment,
    fetchAddressByCep
}